<template>
  <div>
    <div class="d-flex" id="wrapper">

      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
               <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp;Pairing Payment</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="mb-4"> Pairing Payment </h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <div class="col-lg-2 col-sm mobile-div">
                      <select class="form-control form-control-sm" name="status" v-model="bankName" >
                        <option value="BCA">BCA</option>
                        <option value="BRI">BRI</option>
                      </select>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <select class="form-control form-control-sm" name="status" v-model="statusPayment" >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <button class="btn btn-primary btn-sm" @click="searchData"> Search </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <input type="text" name="" class="form-control form-control-sm mb-2 search-field" placeholder="Company Name" v-model="companyName" @keyup.enter="searchDataPayment">
                    <span style="float: right; padding-top: 3px;"> Search : &nbsp;</span>
                    <table class="table table-sm table-bordered table-striped table-responsive-sm">
                      <thead class="">
                        <tr>
                          <th>Payment ID</th>
                          <th>Company Name</th>
                          <th>Invoice Number</th>
                          <th>Billing Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="loadingTable === true">
                          <td colspan="4" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="loadingTable === false && totalData == '0'">
                          <td colspan="4" class="text-center">Data Not Available</td>
                        </tr>
                        <tr v-for="(data, index) in dataPayment" :key="`payment-${index}`" v-else>
                          <td>{{ data.paymentId }}</td>
                          <td>{{ data.companyName }}</td>
                          <td>{{ data.invoiceNumber }}</td>
                          <td>Rp {{ formatPrice(data.totalAmount) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div id="wrapperr">
                      <div id="c1">
                        <div class="alignLeft total-data">
                          Total Data {{ totalData }} 
                        </div>
                      </div>
                      <div id="c2">
                        <div class="pagination p8 alignRight">
                          <ul>
                            <a class="is-active link" @click="toDataPage(currentPage-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                            <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                            <a class="is-active link" @click="toDataPage(currentPage+1)" v-if="currentPage != totalPage"><li>></li></a>
                          </ul>
                        </div>
                      </div>
                    </div>​
                  </div>
                  <div class="col-lg-6">
                    <input type="text" name="" class="form-control form-control-sm mb-2 search-field" placeholder="Mutation Amount" v-model="amountSearch" @keyup.enter="searchData">
                    <span style="float: right; padding-top: 3px;"> Search : &nbsp;</span>
                    <table class="table table-sm table-bordered table-striped table-responsive-sm">
                      <thead class="">
                        <tr>
                          <th>Mutation Date</th>
                          <th>Mutation Desc</th>
                          <th>Mutation Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="loadingTableMutation === true">
                          <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="loadingTableMutation === false && totalDataMutation == '0'">
                          <td colspan="5" class="text-center">Data Not Available</td>
                        </tr>
                        <tr v-for="(data, index) in dataMutation" :key="`mutation-${index}`" v-else>
                          <td>{{ data.mutationDate }}</td>
                          <td>{{ data.mutationDesc }}</td>
                          <td>Rp {{ formatPrice(data.mutationAmount) }}</td>
                          <td class="text-center">
                            <button class="btn btn-primary btn-sm" @click="openModal('Pair',data.noUrut,data.mutationAmount)" v-if="data.noTiket == null"> Pair </button>
                            <button class="btn btn-danger btn-sm mt-1" @click="openModal('Refund',data.noUrut)" v-if="data.noTiket == null"> Refund </button>
                            <div v-if="data.noTiket != null && subTiket(data.noTiket) != 'Refunded'">
                              {{ data.noTiket }}
                              <button class="btn btn-warning btn-sm mt-1" @click="openModal('Reset',data.noUrut,data.noTiket)" v-if="data.noTiket != null"> Reset </button>
                            </div>
                            <div v-else-if="data.noTiket != null && subTiket(data.noTiket) == 'Refunded'">
                              {{ data.noTiket }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div id="wrapperr">
                      <div id="c1">
                        <div class="alignLeft total-data">
                          Total Data {{ totalDataMutation }} 
                        </div>
                      </div>
                      <div id="c2">
                        <div class="pagination p8 alignRight">
                          <ul>
                            <a class="is-active link" @click="toDataPageMutation(currentPageMutation-1)" v-if="currentPageMutation != 1"><li>{{'<'}}</li></a>
                            <a class="page"><li>{{ currentPageMutation }} of {{ totalPageMutation }} page</li></a>
                            <a class="is-active link" @click="toDataPageMutation(currentPageMutation+1)" v-if="currentPageMutation != totalPageMutation"><li>></li></a>
                          </ul>
                        </div>
                      </div>
                    </div>​
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- modalPair -->
      <div class="modal fade" id="modalPair" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Pair Payment</h4>
                <h6>{{ pilih }}</h6> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="one-line">
                <label class="ol-label"> Payment ID</label>
                <label class="ol-titik2">:</label>
                <input type="text" name="note" class="form-control form-control-sm" v-model="paymentId">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="cekAmount">Pair</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Pair</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalRefund -->
      <div class="modal fade" id="modalRefund" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Refund Payment</h4>
                <h6>{{ pilih }}</h6> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p> Are you sure refund this transaction?</p>
              <div class="one-line">
                <label class="ol-label"> Notes </label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm text-area" v-model="note"></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="cekRefund">Refund</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Refund</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalReset -->
      <div class="modal fade" id="modalReset" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Reset Payment</h4>
                <h6>{{ pilih }}</h6> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p> Are you sure reset Payment ID {{ paymentId }}?</p>
              <div class="one-line">
                <label class="ol-label"> Notes </label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm text-area" v-model="note"></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="cekReset">Reset</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Reset</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
  import SideBar from '../SideBar'
  export default {
    name: 'OrderPage',
    components:{
      SideBar
    },
    data () {
      return {
        spaceRegex: /[\u00A0\uFEFF\u202F]/g,
        admin:"",
        permission:[],
        viewDashboard: false,
        viewOrder: false,
        viewReturn: false,
        viewProduct: false,
        viewPairing: false,
        viewReconcile: false,
        viewResolution: false,
        viewLessor: false,
        viewLessee: false,
        viewEmployee: false,
        editOrder: false,
        editReturn: false,
        editProduct: false,
        editPairing: false,
        editReconcile: false,
        editResolution: false,
        editLessor: false,
        editLessee: false,
        editEmployee: false,
        dataPayment: [],
        dataMutation: [],
        totalPage:0,
        totalData:0,
        currentPage:1,
        totalPageMutation:0,
        totalDataMutation:0,
        currentPageMutation:1,
        orderId:"",
        companyName:"",
        statusPayment:1,
        bankName:'BCA',
        loadingTable:true,
        loadingTableMutation:true,
        loadingButtonProcess:false,
        pilih:"",
        paymentId:'',
        mutationAmount:'',
        adminId:'',
        note:'',
        amountSearch:'',
        companyName:'',
        noTiketValue:''
      }
    },
    methods: {
      openModal(p,q,r) {
        this.pilih = q
        this.mutationAmount = r
        if (p == 'Reset') {
          this.paymentId = r
        }
        $("#modal"+p).modal('show')
      },
      formatPrice(value) {
        let val = (value)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cekAmount(){
        if(this.paymentId == ''){
          swal("Sorry", "Payment Id must be fill", "error", {
            button: "Ok",
          })
        }else{
          var sama = 0;
          for(var i=0; i<this.dataPayment.length; i++){
            if (this.paymentId == this.dataPayment[i].paymentId) {
              sama = sama +1
            }
          }
          if (sama == 0) {
            swal("Sorry", "Wrong payment Id", "error", {
              button: "Ok",
            })
          }else{
            this.submitPair()
          }
        }
      },
      submitPair(){
        this.loadingButtonProcess = true
        this.$http.post(process.env.PAIR_PAYMENT,{
          paymentId: this.paymentId,
          noUrut: this.pilih,
          bankName: this.bankName !== null ? this.bankName.replace(this.spaceRegex, ' ') : this.bankName,
          adminId: this.adminId
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.loadingButtonProcess = false
            $('#modalPair').modal('hide')
            this.getData()
          }else if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          }else if (response.data.status == 201) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            this.loadingButtonProcess = false
            $('#modalPair').modal('hide')
            this.getData()
          }
        })
        .catch(error => {
          console.log(error)
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      subTiket: function(x){
        var data = x.substring(0,8) 
        return data
      },
      cekRefund(){
        if (this.note == '') {
          swal("Sorry", "Note must be fill", "error", {
              button: "Ok",
            })
        }else{
          this.submitRefund()
        }
      },
      submitRefund(){
        this.loadingButtonProcess = true
        this.$http.post(process.env.REFUND_PAYMENT,{
          noUrut: this.pilih,
          bankName: this.bankName !== null ? this.bankName.replace(this.spaceRegex, ' ') : this.bankName,
          adminId: this.adminId,
          note: this.note !== null ? this.note.replace(this.spaceRegex, ' ') : this.note
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.loadingButtonProcess = false
            $('#modalRefund').modal('hide')
            this.getData()
            this.note = ''
          }else if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          }else if (response.data.status == 201) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            this.loadingButtonProcess = false
            $('#modalRefund').modal('hide')
            this.getData()
            this.note = ''
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      cekReset(){
        if (this.note == '') {
          swal("Sorry", "Note must be fill", "error", {
              button: "Ok",
            })
        }else{
          this.submitReset()
        }
      },
      submitReset(){
        this.loadingButtonProcess = true
        this.$http.post(process.env.RESET_PAYMENT,{
          paymentId: this.paymentId,
          noUrut: this.pilih,
          bankName: this.bankName !== null ? this.bankName.replace(this.spaceRegex, ' ') : this.bankName,
          adminId: this.adminId,
          note: this.note !== null ? this.note.replace(this.spaceRegex, ' ') : this.note
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.loadingButtonProcess = false
            $('#modalReset').modal('hide')
            this.getData()
            this.note = ''
          }else if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          }else if (response.data.status == 201) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            this.loadingButtonProcess = false
            $('#modalReset').modal('hide')
            this.getData()
            this.note = ''
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      searchData(){
        this.loadingTableMutation = true
        this.$http.post(process.env.SEARCH_DATA_MUTATION,{
          bankName: this.bankName !== null ? this.bankName.replace(this.spaceRegex, ' ') : this.bankName,
          statusPayment: this.statusPayment,
          amount: this.amountSearch !== null ? this.amountSearch.replace(this.spaceRegex, ' ') : this.amountSearch,
          page:1
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          this.dataMutation = response.data.content.dataMutation
          this.totalPageMutation = response.data.content.totalPage
          this.totalDataMutation = response.data.content.totalData
          this.loadingTableMutation = false
          localStorage.setItem('bankName', this.bankName)
          localStorage.setItem('statusPayment', this.statusPayment)
          localStorage.setItem('amountSearch', this.amountSearch)
          localStorage.setItem('companyName', this.companyName)
          this.$router.push('/payment/pairing/search')
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      searchDataPayment(){
        this.loadingTable = true
        this.$http.post(process.env.SEARCH_DATA_PAYMENT,{
          companyName: this.companyName !== null ? this.companyName.replace(this.spaceRegex, ' ') : this.companyName,
          page:1
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
          this.dataPayment = response.data.content.data
          this.totalPage = response.data.content.totalPage
          this.totalData = response.data.content.totalData
          this.loadingTable = false
          localStorage.setItem('companyName', this.companyName)
          localStorage.setItem('bankName', this.bankName)
          localStorage.setItem('statusPayment', this.statusPayment)
          localStorage.setItem('amountSearch', this.amountSearch)
          this.$router.push('/payment/pairing/search')
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      toDataPageMutation(pagePost){
        this.loadingTableMutation = true
        this.$http.post(process.env.GET_DATA_MUTATION,{
          page: pagePost
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            this.loadingTableMutation = false
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
          this.dataMutation = response.data.content.dataMutation
          this.totalPageMutation = response.data.content.totalPage
          this.totalDataMutation = response.data.content.totalData
          this.loadingTableMutation = false
          this.currentPageMutation = response.data.content.currentPage
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      toDataPage(pagePost){
        this.loadingTable = true
        this.$http.post(process.env.GET_DATA_PAYMENT,{
          page: pagePost
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            this.loadingTable = false
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
          this.dataPayment = response.data.content.data
          this.totalPage = response.data.content.totalPage
          this.totalData = response.data.content.totalData
          this.currentPage = response.data.content.currentPage
          this.loadingTable = false
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      toPage(e) {
        this.$router.push(e)
      },
      async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
      cekLogin(){
        if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
        }
      },
      cekPermission(){
        this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
        for(var i=0; i < this.permission.length; i++){
          if( this.permission[i] == "1"){
            this.viewDashboard = true
          }
          if( this.permission[i] == "2.1"){
            this.viewOrder = true
          }
          if( this.permission[i] == "2.2"){
            this.editOrder = true
          }
          if( this.permission[i] == '3.1'){
            this.viewReturn = true
          }
          if( this.permission[i] == '3.2'){
            this.editReturn = true
          }
          if( this.permission[i] == '4.1'){
            this.viewProduct = true
          }
          if( this.permission[i] == '4.2'){
            this.editProduct = true
          }
          if( this.permission[i] == '5.1'){
            this.viewPairing = true
          }
          if( this.permission[i] == '5.2'){
            this.editPairing = true
          }
          if( this.permission[i] == '6'){
            this.viewReconcile = true
          }
          if( this.permission[i] == '7.1'){
            this.viewResolution = true
          }
          if( this.permission[i] == '7.2'){
            this.editResolution = true
          }
          if( this.permission[i] == '8.1'){
            this.viewLessor = true
          }
          if( this.permission[i] == '8.2'){
            this.editLessor = true
          }
          if( this.permission[i] == '9.1'){
            this.viewLessee = true
          }
          if( this.permission[i] == '9.2'){
            this.editLessee = true
          }
          if( this.permission[i] == '10'){
            this.viewEmployee = true
          }
        }
        if (this.viewPairing == false) {
          this.$router.push('/')
        }
      },
      sidebar(){
        $("#wrapper").toggleClass("toggled");
      },
      toDetail(id){
        this.$router.push('/order/detail/' + id)
      },
      getData(){
        this.loadingTableMutation = true
        this.loadingTable = true
        this.$http.get(process.env.GET_DATA_PAYMENT,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                  button: "Ok",
                })
            // this.handleLogout()
          }else{
            this.dataPayment = response.data.content.data
            this.totalPage = response.data.content.totalPage
            this.totalData = response.data.content.totalData
            this.loadingTable = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })


        this.$http.get(process.env.GET_DATA_MUTATION,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                  button: "Ok",
                })
            // this.handleLogout()
          }else{
            this.dataMutation = response.data.content.dataMutation
            this.totalPageMutation = response.data.content.totalPage
            this.totalDataMutation = response.data.content.totalData
            this.loadingTableMutation = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
    },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.adminId = localStorage.getItem('admin_id')
      this.cekLogin()
      this.cekPermission()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.one-line{
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label{
  width: 138px;
  margin: 2px 0px;
}

.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}

.pagination{
  padding: 0px 0;
}

.pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover{
  text-decoration: none;
}
.p8 a.page:hover{
  text-decoration: none;
  color: #fff;
}

.p8 .is-active{
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}
.alignright {
  float: right;
}

.pagg{
  display: inline-flex;
  overflow:auto;
}

.total-data{
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}
#wrapperr{
    overflow:auto;
    margin: 5px 3px;
}

#c1{
   float:left;
}

#c2{
  float: right;  
}

.search-table{
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}
.active{
  color: #2797FB;
}
.right-dropdown{
  margin-left: 7px;
}
.account-div{
  margin: 2px 2px;
}
.right-arrow{
  margin-left: auto;
}
.brand-logo{
  width: 120px;
}
.menu-title{
  margin-left: 1.125rem;
}
.menu-title-order{
  margin-left: 1.95rem;
}
.menu-title-payment{
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}
   .nav-side-menu ul :not(collapsed) .arrow:before,
   .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  .text-area{
    height: 80px;
  }
  .search-field{
    width: 150px;
    float: right;
  }
  textarea{
    resize: none;
  }

  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Payment/PaymentPairingPage.vue